var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkingDesk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Office-Desk--Streamline-Ultimate.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.8335 1.83984H20.8335C20.8335 1.83984 23.3335 1.83984 23.3335 4.33984V14.3398C23.3335 14.3398 23.3335 16.8398 20.8335 16.8398H5.8335C5.8335 16.8398 3.3335 16.8398 3.3335 14.3398V4.33984C3.3335 4.33984 3.3335 1.83984 5.8335 1.83984Z",
    stroke: "#101820",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M36.6667 26.9898C36.5605 27.1946 36.4003 27.3665 36.2035 27.4869C36.0067 27.6074 35.7808 27.6718 35.55 27.6732H4.51671C4.27478 27.6843 4.03473 27.6259 3.825 27.5048C3.61527 27.3836 3.44465 27.2049 3.33338 26.9898L2.08338 23.6565C1.98126 23.47 1.92773 23.2608 1.92773 23.0482C1.92773 22.8355 1.98126 22.6263 2.08338 22.4398C2.20214 22.2211 2.38687 22.0453 2.61129 21.9376C2.83572 21.8299 3.08839 21.7957 3.33338 21.8398H36.6667C36.8795 21.8362 37.0894 21.89 37.2741 21.9956C37.4589 22.1012 37.6118 22.2546 37.7167 22.4398C37.8188 22.6263 37.8723 22.8355 37.8723 23.0482C37.8723 23.2608 37.8188 23.47 37.7167 23.6565L36.6667 26.9898Z",
    stroke: "#101820",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.75 27.6731L5 39.3398",
    stroke: "#101820",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M31.25 27.6731L35 39.3398",
    stroke: "#101820",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.8335 16.8398L9.5835 21.8398",
    stroke: "#101820",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.8335 16.8398L17.0835 21.8398",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M28.3335 15.1731H35.0002V21.8398H28.3335V15.1731Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M32.5 15.1733L34.1667 9.75659",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkingDesk);
export default __webpack_public_path__ + "static/media/workingDesk.b0bbfdc1a97982b2f620f3d793ebd54a.svg";
export { ForwardRef as ReactComponent };